import { render } from "./Product.vue?vue&type=template&id=3fa5ebe5&scoped=true&lang=pug&bindings={\"data\":\"props\",\"index\":\"props\",\"title\":\"setup\",\"changeModalStatus\":\"setup\",\"className\":\"setup\",\"style\":\"setup\"}"
import script from "./Product.vue?vue&type=script&lang=js"
export * from "./Product.vue?vue&type=script&lang=js"

import "./Product.vue?vue&type=style&index=0&id=3fa5ebe5&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-3fa5ebe5"

export default script